import {Component, Input, OnInit, Output, SimpleChanges, EventEmitter} from '@angular/core';
import {FinancialChartDetails} from '../../_models/financial-account.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {FinancialChartService} from '../../_services/financial-chart.service';

@Component({
    selector: 'acabim-admin-edit-class',
    templateUrl: './edit-class.component.html',
    styleUrls: ['./edit-class.component.scss'],
    providers: [MessageService]
})
export class EditClassComponent implements OnInit {

    constructor(private messageService: MessageService,
                private primengConfig: PrimeNGConfig,
                private readonly financialService: FinancialChartService) {
        this.editClassForm = new FormGroup({
            className: new FormControl(null, Validators.required),
            description: new FormControl(null, Validators.required),
            identifier: new FormControl(null, Validators.required),
            status: new FormControl(false)
        });
    }

    @Input() classDetail?: FinancialChartDetails;
    @Output() closeModal = new EventEmitter<string>();
    editClassForm: any;
    isLoading = false;

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges(changes: SimpleChanges): void {
        if (this.classDetail) {
            this.editClassForm.get('className').setValue(this.classDetail.name);
            this.editClassForm.get('description').setValue(this.classDetail.description);
            this.editClassForm.get('identifier').setValue(this.classDetail.identifier);
            this.editClassForm.get('status').setValue(this.classDetail.status === 'active');
            this.editClassForm.get('status').updateValueAndValidity();
        }
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
    }

    onSubmit() {
        if (this.editClassForm.valid) {
            this.isLoading = true;
            if (this.classDetail) {
                this.financialService.updateClass(this.classDetail.id, this.editClassForm.get('identifier').value,
                    this.editClassForm.get('className').value,
                    this.editClassForm.get('description').value).subscribe(data => {
                    // @ts-ignore
                    if ((this.classDetail.status === 'active') !== this.editClassForm.get('status').value) {
                        this.financialService.toggleClassStatus(this.classDetail?.id).subscribe(() => {
                            this.isLoading = false;
                            this.closeModal.emit('class ' + this.classDetail?.id + ':  details and status has been updated');
                        }, error => {
                            this.isLoading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Class details updated, cannot update class status'
                            });
                        });
                    } else {
                        this.isLoading = false;
                        this.closeModal.emit('class ' + this.classDetail?.id + ':  details has been updated');
                    }
                }, error => {
                    this.isLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot update class, please contact administrator'
                    });
                });
            } else {
                this.financialService.addNewClass(this.editClassForm.get('identifier').value,
                    this.editClassForm.get('className').value,
                    this.editClassForm.get('description').value).subscribe(data => {
                    this.isLoading = false;
                    this.closeModal.emit('class has been created');
                }, error => {
                    this.isLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot add class, please contact administrator'
                    });
                });
            }
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please fill all required fields'
            });
        }
    }
}
